import UserAPI from "../../api-services/user";
import * as ACTION_TYPE from "./constants";

export const loadInAppMessages =
  ({ from = 0, to = 50 } = {}) =>
  (dispatch, getState) => {
    const { user } = getState();
    const userAPI = new UserAPI(user);

    dispatch({
      type: ACTION_TYPE.LOAD_IN_APP_MESSAGES.STARTED,
      payload: { from, to },
    });

    return userAPI
      .loadInAppMessages({ from, to })
      .then((messages) =>
        dispatch({
          type: ACTION_TYPE.LOAD_IN_APP_MESSAGES.SUCCESS,
          payload: { messages, from, to },
        }),
      )
      .catch((error) => {
        console.error(error);
        return dispatch({
          type: ACTION_TYPE.LOAD_IN_APP_MESSAGES.FAILED,
          payload: { error, from, to },
        });
      });
  };

export const loadUnseenMessagesCount = () => (dispatch, getState) => {
  const { user } = getState();

  if (!user.loggedIn) {
    return;
  }

  const userAPI = new UserAPI(user);

  dispatch({
    type: ACTION_TYPE.LOAD_UNSEEN_MESSAGES_COUNT.STARTED,
  });

  return userAPI
    .getUnseenMessagesCount()
    .then((count) =>
      dispatch({
        type: ACTION_TYPE.LOAD_UNSEEN_MESSAGES_COUNT.SUCCESS,
        payload: { count },
      }),
    )
    .catch((error) => {
      console.error(error);
      return dispatch({
        type: ACTION_TYPE.LOAD_UNSEEN_MESSAGES_COUNT.FAILED,
        payload: { error },
      });
    });
};

export const markMessageAsSeen = (messageIds) => (dispatch, getState) => {
  const { user } = getState();
  const userAPI = new UserAPI(user);

  dispatch({
    type: ACTION_TYPE.MARK_MESSAGE_AS_SEEN.STARTED,
    payload: { messageIds },
  });

  return userAPI
    .markMessagesAsSeen(messageIds)
    .then((isSuccess) => {
      dispatch({
        type: ACTION_TYPE.MARK_MESSAGE_AS_SEEN.SUCCESS,
        payload: { messageIds, isSuccess },
      });
      // Reload unseen count
      dispatch(loadUnseenMessagesCount());
    })
    .catch((error) => {
      console.error(error);
      return dispatch({
        type: ACTION_TYPE.MARK_MESSAGE_AS_SEEN.FAILED,
        payload: { error, messageIds },
      });
    });
};

export const markMessageAsHidden = (messageIds) => (dispatch, getState) => {
  const { user } = getState();
  const userAPI = new UserAPI(user);

  dispatch({
    type: ACTION_TYPE.MARK_MESSAGE_AS_HIDDEN.STARTED,
    payload: { messageIds },
  });

  return userAPI
    .markMessagesAsHidden(messageIds)
    .then((isSuccess) => {
      dispatch({
        type: ACTION_TYPE.MARK_MESSAGE_AS_HIDDEN.SUCCESS,
        payload: { messageIds, isSuccess },
      });
      // Reload unseen count
      dispatch(loadUnseenMessagesCount());
      dispatch(loadInAppMessages());
    })
    .catch((error) => {
      console.error(error);
      return dispatch({
        type: ACTION_TYPE.MARK_MESSAGE_AS_HIDDEN.FAILED,
        payload: { error, messageIds },
      });
    });
};

export const unhideMessage = (messageIds) => (dispatch, getState) => {
  const { user } = getState();
  const userAPI = new UserAPI(user);

  dispatch({
    type: ACTION_TYPE.UNHIDE_MESSAGE.STARTED,
    payload: { messageIds },
  });

  return userAPI
    .unhideMessages(messageIds)
    .then((isSuccess) => {
      dispatch({
        type: ACTION_TYPE.UNHIDE_MESSAGE.SUCCESS,
        payload: { messageIds, isSuccess },
      });
      // Reload messages and unseen count
      dispatch(loadUnseenMessagesCount());
      dispatch(loadInAppMessages());
    })
    .catch((error) => {
      console.error(error);
      return dispatch({
        type: ACTION_TYPE.UNHIDE_MESSAGE.FAILED,
        payload: { error, messageIds },
      });
    });
};
